/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteValues.defs.js'
export * as $defs from './deleteValues.defs.js'
